interface CodeMessagesMap {
  [key: number]: string;
}

export const CODE_MESSAGE: Readonly<CodeMessagesMap> = Object.freeze({
  200: 'Success',
  227: 'Incorrect invitation',
  228: 'This email already exists. Login or use Forgot password to access your account',
  229: 'Incorrect username or password',
  230: 'Too many request',
  231: 'Too many attempts with incorrect password',
  232: 'Invalid parameter exception',
  233: 'User was blocked',
  234: 'Incorrect uuid',
  236: 'Email change is not allowed',
});
